import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import { ConfigContext } from './ConfigContext';
import { setConfig } from './configService';

export const ConfigProvider = ({ children }) => {
  const [appConfig, setAppConfig] = useState(null);

  useEffect(() => {
    const loadConfig = async () => {
      try {
        const res = await fetch('/deployment-config.json', {
          cache: 'no-store',
        });

        if (!res.ok) {
          throw new Error('Failed to load config');
        }

        const data = await res.json();
        const normalizedAppConfig = {
          apiUrl: data.API_URL,
          smartyStreetsWebsiteKey: data.SMARTYSTREETS_WEBSITE_KEY,
          smartyStreetEnforce: data.SMARTYSTREETS_ENFORCE,
          envLabel: data.ENV_LABEL,
          env: data.ENV,
          isSmartyStreetsDisabled: data.IS_SMARTY_STREETS_DISABLED,
        };
        setConfig(normalizedAppConfig);
        setAppConfig(normalizedAppConfig);
      } catch (err) {
        console.error('Config load error:', err);
        setConfig({});
        setAppConfig({});
      }
    };

    loadConfig();
  }, []);

  if (!appConfig) {
    return null;
  }

  return (
    <ConfigContext.Provider value={appConfig}>
      {children}
    </ConfigContext.Provider>
  );
};

ConfigProvider.propTypes = {
  children: PropTypes.node.isRequired,
};
